<template>
  <div></div>
</template>

<script>
import { getAtolCertificate } from "./services";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      errorLoadingData: false,
    };
  },
  methods: {
    showError(variant = null, _text) {
      this.$bvToast.toast(_text, {
        title: 'ATOL Certificate',
        variant: variant,
        solid: true,
      });
    },
    async getAtolCertificate() {
      this.$store.dispatch("spinner/updateLoadingAction", true, { root: true });
      let system = 'UK'
      if (this.getBookingNumber.charAt(0).toUpperCase() === 'R') {
        system = 'IE'
      }
      let result = await getAtolCertificate({
        booknum: this.getBookingNumber,
        name: this.getBookingSurname,
        system: system
      });
      if (!result || result.error) {
        // display alert
        this.$store.dispatch("spinner/updateLoadingAction", false, {
          root: true,
        });
        this.showError('danger', 'Error loading PDF');
        return;
      }
      const file = new Blob([result.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      const a = document.createElement("a");
      a.href = fileURL;
      a.setAttribute("download", `ATOL Certificate - Trailfinders Booking ${this.getBookingNumber}`);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(fileURL);
      this.$store.dispatch("spinner/updateLoadingAction", false, {
        root: true,
      });
    },
  },
  computed: {
    // Bring in the standard bookno & surname
    ...mapGetters("booking", [
      "getBookingNumber",
      "getBookingSurname",
    ]),
  },
};
</script>
